import React from 'react';

import { SVGComponentProps } from './svg.types';

const ArchiveWhiteSVG = ({
  fill = 'none',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 16 16"
        fill={fill}
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M13.3333 2.66663H2.66659C1.93021 2.66663 1.33325 3.26358 1.33325 3.99996V4.66663C1.33325 5.40301 1.93021 5.99996 2.66659 5.99996H13.3333C14.0696 5.99996 14.6666 5.40301 14.6666 4.66663V3.99996C14.6666 3.26358 14.0696 2.66663 13.3333 2.66663Z"
          stroke="#131720"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.66675 6V12C2.66675 12.3536 2.80722 12.6928 3.05727 12.9428C3.30732 13.1929 3.64646 13.3333 4.00008 13.3333H12.0001C12.3537 13.3333 12.6928 13.1929 12.9429 12.9428C13.1929 12.6928 13.3334 12.3536 13.3334 12V6"
          stroke="#131720"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.66675 8.66663H9.33341"
          stroke="#131720"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
};

export default ArchiveWhiteSVG;
